// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2Orec","search":"Settings_search__1W8To","filter":"Settings_filter__1JEVw"};